import { useRef, useState } from "react"
import { GiHamburgerMenu } from "react-icons/gi"
import { MdCancel } from "react-icons/md"
import Button from "../../components/shared-components/Button"
import useClickOut from "../../util/useClickOut"
import { Link } from "react-router-dom"
import {
  landingPathName,
  loginPathName,
  signUpPathName,
} from "../../components/routes/pathName"
import { navLists } from "../../components/shared-components/Datas"

const Nav = () => {
  const [showToggle, setShowToggle] = useState(false)
  const navRef = useRef(null)

  useClickOut(navRef, () => setShowToggle(false))

  function handleToggle() {
    setShowToggle(!showToggle)
  }

  return (
    <div
      ref={navRef}
      className="flex flex-wrap lg:flex-nowrap items-center justify-between  gap-12 "
    >
      <Link to={landingPathName}>
        <h1 className="text-[2rem] sm:text-[3rem] font-playfair font-black italic  ">
          Logistifly
        </h1>
      </Link>
      <button
        className=" relative z-40 text-[2rem] lg:hidden "
        onClick={handleToggle}
      >
        {showToggle ? (
          <MdCancel className="text-[#AFAFAF] " />
        ) : (
          <GiHamburgerMenu className="text-[#174078] " />
        )}
      </button>
      <div
        className={`
transition-all duration-300 ease-in-out
${
  showToggle
    ? "opacity-100 translate-y-0 pointer-events-auto"
    : "opacity-0 -translate-y-5 pointer-events-none"
}
lg:opacity-100 lg:translate-y-0 lg:pointer-events-auto
absolute lg:static -left-5 right-0 top-0 p-5 lg:p-0
bg-white lg:bg-inherit text-primary-300 lg:text-white
flex flex-col lg:flex-row justify-between items-baseline
gap-y-[1.8rem] w-minus-2.5rem lg:w-full
`}
      >
        <ul className="flex flex-col mt-14 lg:mt-0 lg:flex-row lg:items-center gap-[1.8rem] ">
          {navLists.map((list) => (
            <li key={list.id} onClick={handleToggle}>
              <a href={`#${list.to}`}>{list.list}</a>
            </li>
          ))}
        </ul>
        <div className="flex flex-col lg:flex-row lg:items-center gap-[0.5rem] w-[40%] ">
          <Link to={loginPathName}>
            <Button
              className={
                " lg:!bg-inherit text-[1.5rem] !text-white !border !border-white font-medium w-full "
              }
              text={"Login"}
            />
          </Link>
          <Link to={signUpPathName}>
            <Button
              className={
                " lg:!bg-inherit text-[1.5rem] !text-white !border !border-white font-medium w-full"
              }
              text={"Sign up"}
            />
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Nav
